/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NavigationCategoryModel } from '../../models/navigation-category-model';

export interface GetNavigationCategory$Params {
      body?: {
'id'?: number;
}
}

export function GetNavigationCategory(http: HttpClient, rootUrl: string, params?: GetNavigationCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<NavigationCategoryModel>> {
  const rb = new RequestBuilder(rootUrl, GetNavigationCategory.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NavigationCategoryModel>;
    })
  );
}

GetNavigationCategory.PATH = '/api/Navigation/GetNavigationCategory';
